import React from "react";
import ReactDOM from "react-dom/client";
import Header from "./components/Header";
import Main from "./components/Main";
import Error from "./components/Error";
import { RouterProvider, createBrowserRouter, Outlet } from "react-router-dom";
const AppLayout = () => {
  // bg-[#152757]
  return (
    <div className="font-cabin
  bg-slate-900
    text-gray-400 
    ">
      <Header />
      <Main />
      {/* <Outlet/> */}
    </div>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      // {
      //   path:"/",
      //   element: <Main />,
      // },
      // {
      //   path:"/projects",
      //   element: <Project />,
      // },
    ],
    errorElement: <Error />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<RouterProvider router={appRouter} />);
